import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { fmtDate, fmtDays } from "../lib/format";
import { toast } from "sonner";
import { ArrowLeft, Scales, Printer } from "@phosphor-icons/react";

export default function ArgumentaireDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get(`/scenarios/argumentaires/${id}`).then((r) => setA(r.data)).catch(() => toast.error("Argumentaire introuvable"));
  }, [id]);

  if (!a) return <div className="p-12 label-mono">Chargement...</div>;

  const sim = a.simulation || {};
  const irh = sim.irh || {};

  return (
    <div className="max-w-[1100px] mx-auto px-4 sm:px-8 py-10">
      <Link to="/scenarios" className="label-mono inline-flex items-center gap-2 mb-6 hover:text-[var(--signal)]" data-testid="arg-back">
        <ArrowLeft size={14} /> Retour aux scénarios
      </Link>

      <div className="border-b border-black pb-6 mb-8 fade-up flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="label-mono">§ Argumentaire juridique de restructuration</div>
          <h1 className="mt-2 font-serif text-3xl sm:text-4xl font-medium tracking-tight flex items-center gap-3">
            <Scales size={32} className="text-[var(--signal)]" /> {a.contexte?.preset_label || "Restructuration"}
          </h1>
          <div className="mt-2 font-mono text-xs text-[var(--muted)]">N° {a.id?.slice(0, 8)} · {fmtDate(a.cree_le)}</div>
        </div>
        <button onClick={() => window.print()} className="border border-black px-4 py-2 hover:bg-black hover:text-[var(--paper)] label-mono flex items-center gap-2 print:hidden">
          <Printer size={14} /> Imprimer
        </button>
      </div>

      {/* Quick metrics */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-black/15 border border-black/15 mb-8">
        <div className="bg-[var(--paper)] p-4">
          <div className="label-mono">IRH</div>
          <div className="text-3xl font-light tabular-nums mt-1">{(irh.irh_pct || 0).toFixed(1)}%</div>
        </div>
        <div className="bg-[var(--paper)] p-4">
          <div className="label-mono">Jours/an sauvés</div>
          <div className="text-3xl font-light tabular-nums mt-1">{fmtDays(irh.jours_economises_par_an || 0, 2)}</div>
        </div>
        <div className="bg-[var(--paper)] p-4">
          <div className="label-mono">Cumul citoyen 20y</div>
          <div className="text-3xl font-light tabular-nums mt-1">{fmtDays(irh.cumul_jours_par_citoyen_20ans || 0, 0)}</div>
        </div>
        <div className="bg-[var(--paper)] p-4 bg-[var(--signal-light)]">
          <div className="label-mono">Restitution collective</div>
          <div className="text-3xl font-light tabular-nums mt-1">{Math.round(irh.cumul_annees_humaines_collectives || 0).toLocaleString("fr-FR")}<span className="text-xs ml-1 text-[var(--muted)]">années humaines</span></div>
        </div>
      </div>

      {/* Document */}
      <article className="border border-black bg-[var(--paper)] paper-grain">
        <div className="p-8 sm:p-12 max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-block stamp-rotate border-2 border-[var(--signal)] text-[var(--signal)] px-4 py-2 font-mono text-xs">
              ARGUMENTAIRE DE RESTRUCTURATION
            </div>
          </div>
          <pre className="whitespace-pre-wrap font-serif text-base leading-relaxed text-[var(--ink)]" data-testid="arg-content">{a.contenu}</pre>
          <div className="mt-12 border-t border-black/15 pt-6 font-mono text-xs text-[var(--muted)] flex items-center justify-between">
            <div>VITA-LEX ANALYTICA · 2026</div>
            <div>Pièce {a.id?.slice(0, 8)}</div>
          </div>
        </div>
      </article>
    </div>
  );
}
